import { TextField } from "@mui/material";
import styled from "styled-components";

export const TextArea = styled(TextField)`
  /* margin-top: 1px !important; */
  > div input {
    padding: 40px 8px !important;
    background-color: white;
  }
`;
